import api from './api';
import { createMarketApi } from './marketApiClient';

export const marketApi = createMarketApi(api);
